import graphqlClient from '../../api/axios_interceptor';

import {
    FETCH_BILLING_DETAILS, UPDATE_SMS_ALERT_PREFERENCES, UPDATE_BILLING_PLAN
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

import {
    getBillingQuery, updateSMSAlertPrefereneces, updateBillingPlan
} from '../../api/graphql/queries/billing';

const fetchBillingMiddleware = async (action) => {
    try{
        let query = getBillingQuery();
        await graphqlClient({
            data: { query }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }else{
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        ...queryResult.data.data.billing
                    }
                }
            }
        });
    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const updateSmsAlertPreferencesMiddleware = async (action) => {
    try{
        let payload = action.payload;
        if (!(payload.lowSmsBalanceReminder == undefined || payload.smsReminderThreshold == undefined)){
            let query = updateSMSAlertPrefereneces(action.payload.lowSmsBalanceReminder, action.payload.smsReminderThreshold);
            await graphqlClient({
                data: { query }
            }).then((queryResult) => {
                if (queryResult.data.errors) {
                    action = updateActionErrors(action, queryResult.data.errors);
                } else {
                    action = {
                        ...action,
                        payload: {
                            ...action.payload,
                            ...queryResult.data.data.updateSmsAlertPreferences
                        }
                    }
                }
            });
        }

    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const updateBillingPlanMiddleware = async (action) => {
    try{
        let payload = action.payload;
        let query = updateBillingPlan(payload);
        await graphqlClient({
            data: { query }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.updateBillingPlan.success == false) {
                action = updateActionErrors(action, queryResult.data.data.updateBillingPlan.message);
            } else if (queryResult.data.data.updateBillingPlan.success == true) {
                const message = queryResult.data.data.updateBillingPlan.message;
                const success = queryResult.data.data.updateBillingPlan.success;
                const customerAccount = queryResult.data.data.updateBillingPlan.customerAccount;
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        customerAccount,
                        message,
                        success
                    }
                }
            }
        });
    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const billingMidddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_BILLING_DETAILS:
            action = await fetchBillingMiddleware(action);
            break;
        case UPDATE_SMS_ALERT_PREFERENCES:
            action = await updateSmsAlertPreferencesMiddleware(action);
            break;
        case UPDATE_BILLING_PLAN:
            action = await updateBillingPlanMiddleware(action);
            break;
        default:
            break;
    }
    return next(action);
}